// Loyola Marymount University's majors (#2739). Read on 2026-10-01 from the
// official LMU Academic Bulletin, 2026-2027 Edition (bulletin.lmu.edu):
// every program on Academic Degrees and Programs by Type, Bachelor's Degrees,
// plus Education and Learning Sciences (Liberal Studies), B.A., which the
// bulletin lists under the School of Education's undergraduate programs.
// Grouped by the college or school whose bulletin pages hold each major, with
// the degree as the bulletin writes it. Mathematics, B.A. (Mathematics
// Education Emphasis) is kept because the bulletin lists it as its own
// bachelor's program. Left out: minors, certificates, credentials, the
// undergraduate teacher preparation programs, accelerated master's programs,
// graduate degrees and General Engineering (no degree of its own).
const majors = {
    "slug": "loyola-marymount-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in LMU's official 2026-2027 Academic Bulletin, grouped by the college or school that offers it. Minors, certificates, credentials and graduate programs are left out.",
    "groups": [
        {
            "name": "Bellarmine College of Liberal Arts",
            "source": {
                "label": "LMU Academic Bulletin 2026-2027, Bellarmine College of Liberal Arts",
                "url": "https://bulletin.lmu.edu/schools-colleges/liberal-arts/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Asian and Pacific Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chicana/o and Latina/o Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics and Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Modern Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theology",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Business Administration",
            "source": {
                "label": "LMU Academic Bulletin 2026-2027, College of Business Administration",
                "url": "https://bulletin.lmu.edu/schools-colleges/business-administration/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Information Systems and Business Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Information Systems and Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Management and Leadership",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "College of Communication and Fine Arts",
            "source": {
                "label": "LMU Academic Bulletin 2026-2027, College of Communication and Fine Arts",
                "url": "https://bulletin.lmu.edu/schools-colleges/communication-fine-arts/"
            },
            "majors": [
                {
                    "name": "Art and Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Choreography and Performance",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Dance Pedagogy and Social Action",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Frank R. Seaver College of Science and Engineering",
            "source": {
                "label": "LMU Academic Bulletin 2026-2027, Frank R. Seaver College of Science and Engineering",
                "url": "https://bulletin.lmu.edu/schools-colleges/science-engineering/"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health and Human Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics (Mathematics Education Emphasis)",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics and Data Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "LMU Academic Bulletin 2026-2027, Education and Learning Sciences (Liberal Studies), B.A.",
                "url": "https://bulletin.lmu.edu/schools-colleges/education/center-undergraduate/education-learning-sciences/"
            },
            "majors": [
                {
                    "name": "Education and Learning Sciences (Liberal Studies)",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Film and Television",
            "source": {
                "label": "LMU Academic Bulletin 2026-2027, School of Film and Television",
                "url": "https://bulletin.lmu.edu/schools-colleges/film-television/"
            },
            "majors": [
                {
                    "name": "Animation",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Television Production",
                    "degree": "B.F.A."
                },
                {
                    "name": "Film, Television, and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Recording Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Screenwriting",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
